export const enum ApiAuthentication {
    Login = "Authentication/Login",
    GetPermission = "Authentication/GetMenuPermission",
    CheckTokenExp = "Authentication/CheckTokenExp",
};
export const enum ApiNavigationType {
    FrontEndTop = "1",
    FrontEndLeft = "2",
    BackEnd = "3"
};
export const enum ApiNavigation {
    GetBreadcrumbs = "Navigation/GetBreadCrumb",
    GetMenu = "Navigation/GetMenu"
};
export const enum ApiCookie {
    Cookie = "Cookie/OnAddCookie",
    CookieHistory = "Cookie/OnAddCookieHistory",
    Privacypolicy = "Cookie/OnGetDataPDPA",
};

export const enum ApiUserChange {
    ChangeSecuredCode = "UserChange/SaveChangeSecuredCode",   
};
export const enum ApiApplyMember {
    GetFormOTP = "ApplyMember/GetFormOTP",
    CheckEmailOTP = "ApplyMember/CheckEmailOTP",
    ChangeOTP = "ApplyMember/ChangeOTP", 
    CancelOTP = "ApplyMember/CancelOTP",
    ChangeSecuredCodeOTP = "ApplyMember/ChangeSecuredCodeOTP",

    GetFormInitial = "ApplyMember/GetFormInitial",
    SaveApplyMember = "ApplyMember/SaveApplyMember",  
};
export const enum ApiLeave {
    GetFormInitial = "Leave/GetFormInitial",  
    GetTableLeave = "Leave/GetTableLeave",  
    GetFormInitialLeave = "Leave/GetFormInitialLeave", 
    CalculateLeaveDate = "Leave/GetCalculateLeaveDate", 
    SaveLeave = "Leave/SaveLeave",  
    GetFormLeaveID = "Leave/GetFormLeaveID",  
    SaveApproveLeaveAll = "Leave/SaveApproveLeaveAll",
    SaveApproveLeave = "Leave/SaveApproveLeave",

    GetProfiles = "Leave/GetProfiles",  
    GetLogHistory = "Leave/GetLogHistory",  
};
export const enum ApiProject {
    GetFormInitial = "Project/GetFormInitial",  
    GetTableProjectRequest = "Project/GetTableProjectRequest", 
    DeleteProject = "Project/DeleteProject",
    GetTableProjectsRequestSupport = "Project/GetTableProjectsRequestSupport",  
    
    GetFormInitialList = "Project/GetFormInitialList",  
    GetTableProject = "Project/GetTableProject",  

    GetFormInitialProject = "Project/GetFormInitialProject", 
    SaveProject = "Project/SaveProject",  
    GetFormProjectID = "Project/GetFormProjectID",  
    GetLogHistory = "Project/GetLogHistory",  

    GetProvinceData = "Project/GetProvinceData",
    GetDistrictData = "Project/GetDistrictData",
    GetSubDistrictData = "Project/GetSubDistrictData",

    GetFormInitialProjectPanel0 = "Project/GetFormInitialProjectPanel0",  
    GetFormInitialProjectPanel1 = "Project/GetFormInitialProjectPanel1",  
    GetFormInitialProjectPanel2 = "Project/GetFormInitialProjectPanel2",  
    GetFormInitialProjectPanel3 = "Project/GetFormInitialProjectPanel3",  
    GetFormInitialProjectPanel4 = "Project/GetFormInitialProjectPanel4",  
    GetFormInitialProjectPanel5 = "Project/GetFormInitialProjectPanel5",  
    GetFormInitialProjectPanel6 = "Project/GetFormInitialProjectPanel6",  
    GetFormInitialProjectPanel7 = "Project/GetFormInitialProjectPanel7",  
    GetFormInitialProjectPanel8 = "Project/GetFormInitialProjectPanel8",  
    GetFormInitialProjectPanel9 = "Project/GetFormInitialProjectPanel9",  
    GetFormInitialProjectPanel10 = "Project/GetFormInitialProjectPanel10",  
    GetFormInitialProjectPanel11 = "Project/GetFormInitialProjectPanel11",  
    GetFormInitialProjectPanel12 = "Project/GetFormInitialProjectPanel12",  

    SaveProjectPanel0 = "Project/SaveProjectPanel0",  
    SaveProjectPanel1 = "Project/SaveProjectPanel1",  
    SaveProjectPanel2 = "Project/SaveProjectPanel2",  
    SaveProjectPanel3 = "Project/SaveProjectPanel3",  
    SaveProjectPanel4 = "Project/SaveProjectPanel4",  
    SaveProjectPanel5 = "Project/SaveProjectPanel5",  
    SaveProjectPanel6 = "Project/SaveProjectPanel6",  
    SaveProjectPanel7 = "Project/SaveProjectPanel7",  
    SaveProjectPanel8 = "Project/SaveProjectPanel8",  
    SaveProjectPanel9 = "Project/SaveProjectPanel9",  
    SaveProjectPanel10 = "Project/SaveProjectPanel10",  
    SaveProjectPanel11 = "Project/SaveProjectPanel11",  
    SaveProjectPanel12 = "Project/SaveProjectPanel12",  

    GetFormProjectID_Panel0 = "Project/GetFormProjectID_Panel0",  
    GetFormProjectID_Panel1 = "Project/GetFormProjectID_Panel1",  
    GetFormProjectID_Panel2 = "Project/GetFormProjectID_Panel2",  
    GetFormProjectID_Panel3 = "Project/GetFormProjectID_Panel3",  
    GetFormProjectID_Panel4 = "Project/GetFormProjectID_Panel4",  
    GetFormProjectID_Panel5 = "Project/GetFormProjectID_Panel5",  
    GetFormProjectID_Panel6 = "Project/GetFormProjectID_Panel6",  
    GetFormProjectID_Panel7 = "Project/GetFormProjectID_Panel7",  
    GetFormProjectID_Panel8 = "Project/GetFormProjectID_Panel8",  
    GetFormProjectID_Panel9 = "Project/GetFormProjectID_Panel9",  
    GetFormProjectID_Panel10 = "Project/GetFormProjectID_Panel10",  
    GetFormProjectID_Panel11 = "Project/GetFormProjectID_Panel11",  
    GetFormProjectID_Panel12 = "Project/GetFormProjectID_Panel12",  

    GetFormInitialProjectWorkPlan = "Project/GetFormInitialProjectWorkPlan",  
    GetFormInitialProjectSpendingPlan = "Project/GetFormInitialProjectSpendingPlan",  

    SaveProjectRequestWorkPlan = "Project/SaveProjectRequestWorkPlan",  
    SaveProjectRequestSpendingPlan = "Project/SaveProjectRequestSpendingPlan",  

    GetFormProjectID_WorkPlan = "Project/GetFormProjectID_WorkPlan",  
    GetFormProjectID_SpendingPlan = "Project/GetFormProjectID_SpendingPlan",  

    ExportExcelWorkPlan = "Project/ExportExcelWorkPlan",      
    ExportExcelSpendingPlan = "Project/ExportExcelSpendingPlan",      

    ExportProjectWord = "Project/ExportWord",      

    GetFormInitialCheckRecordNormal = "Project/GetFormInitialCheckRecordNormal",
    GetTableCheckRecordNormal = "Project/GetTableCheckRecordNormal",  
    GetFormCommitteeNormal = "Project/GetFormCommitteeNormal",
    SaveCommitteeNormal = "Project/SaveCommitteeNormal",

    GetFormInitialCheckRecordFastTrack = "Project/GetFormInitialCheckRecordFastTrack",  
    GetTableCheckRecordFastTrack = "Project/GetTableCheckRecordFastTrack", 
    GetFormCommitteeFastTrack = "Project/GetFormCommitteeFastTrack",

    GetProjectCheckList = "Project/GetProjectCheckList",
    SaveProjectCheckList = "Project/SaveProjectCheckList",

    GetFormInitialProjectScore = "Project/GetFormInitialProjectScore",
    SaveProjectScore = "Project/SaveProjectScore",
    SaveProjectScoreAuto = "Project/SaveProjectScoreAuto",

    GetFormInitialProjectScoreSummary = "Project/GetFormInitialProjectScoreSummary",

    GetFormInitialProjectArrangeOrder = "Project/GetFormInitialProjectArrangeOrder",
    GetFormProjectArrangeOrder = "Project/GetFormProjectArrangeOrder",
    SaveProjectArrangeOrder = "Project/SaveProjectArrangeOrder",
    SaveProjectChangesOrder = "Project/SaveProjectChangesOrder",

    GetFormProjectResultLetter = "Project/GetFormProjectResultLetter",
    SaveProjectResultLetter = "Project/SaveProjectResultLetter",

    ExportGenPDFProject = "Project/ExportGenPDFProject",
    SavePDFProject = "Project/SavePDFProject",

    GetFormProjectChangeStatus = "Project/GetFormProjectChangeStatus",
    SaveProjectChangeStatus = "Project/SaveProjectChangeStatus",

    SaveProjectVersion = "Project/SaveProjectVersion",

    ExportProjectExcelReadyPresent = "Project/ExportProjectExcelReadyPresent",  
    ExportProjectExcelList = "Project/ExportProjectExcelList",  

    GetFormProjectPresent403 = "Project/GetFormProjectPresent403",
    SaveProjectPresent403 = "Project/SaveProjectPresent403",

    GetFormProjectPresent404 = "Project/GetFormProjectPresent404",
    SaveProjectPresent404 = "Project/SaveProjectPresent404",

    GetFormProjectClose = "Project/GetFormProjectClose",
    SaveProjectClose = "Project/SaveProjectClose",

    GetFormInitialProjectQuater = "Project/GetFormInitialProjectQuater",
    GetFormProjectID_Quater = "Project/GetFormProjectID_Quater",
    SaveProjectQuater = "Project/SaveProjectQuater",

    SaveDataMigrationProject = "Project/SaveDataMigrationProject",

    SaveProjectCheckPlan = "Project/SaveProjectCheckPlan",
};


